import { useQuery } from '@apollo/client';
import { graphql } from '~/apollo/generated/v3';
import { NotFound } from '~/components/common/NotFound';
import { PageHeading } from '~/components/common/PageHeading';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { useBreadcrumb } from '~/components/layout/Breadcrumb';
import { UpdateProjectForm } from '~/components/upload/project/update-project-form';
import { StudyAccessManager } from '~/components/upload/study/study-access-manager';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const UPLOAD_PROJECT_UPDATE_PAGE = graphql(`
  query UploadProjectUpdatePage($id: Int!) {
    projectList(id: $id) {
      ...projectParts
      studyAccess {
        ...studyAccessManagerParts
      }
    }
  }
`);

export default function UploadProjectUpdatePage() {
  const projectId = useRouteParam('projectId', parseInt);

  const { data, loading } = useQuery(UPLOAD_PROJECT_UPDATE_PAGE, {
    variables: { id: projectId },
  });

  const refetchQueries = createRefetchQueries([
    {
      query: UPLOAD_PROJECT_UPDATE_PAGE,
      variables: { id: projectId },
    },
  ]);

  const project = data?.projectList.find(p => p.id === projectId);
  const studyAccess = project?.studyAccess.filter(p => !!p.company) ?? [];

  useBreadcrumb(
    'routes/upload/model/project/$projectId',
    project?.name ?? 'Update Project',
  );

  if (loading) return <SpinnerPlaceholder />;
  if (!project) return <NotFound />;

  return (
    <>
      <PageHeading>{project.name}</PageHeading>

      <div className="grid lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2">
          <UpdateProjectForm
            project={project}
            refetchQueries={refetchQueries}
          />
        </div>

        <div className="lg:col-span-1">
          <StudyAccessManager
            parentType="project"
            parentId={projectId}
            studyAccess={studyAccess}
            refetchQueries={refetchQueries}
          />
        </div>
      </div>
    </>
  );
}
